export default () => {
  'ngInject';
  return {
    restrict: 'A',
    scope: {
      onCtrlS: '&',
    },
    link: (scope, element) => {
      element.bind('keydown', function (event) {
        if (event.keyCode === 83 && event.ctrlKey) {
          event.preventDefault();
          scope.onCtrlS();
        }
      });
    },
  };
};
